import { Link, useRouteError } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Construction, SearchX, ShieldX, TriangleAlert } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { EmptyState } from '@/components/EmptyState'

export function ForbiddenPage() {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-dvh items-center justify-center bg-surface-page">
      <EmptyState
        icon={ShieldX}
        title={t('errors.forbiddenTitle')}
        description={t('errors.forbiddenDescription')}
      >
        <Button variant="outline" className="mt-2" asChild>
          <Link to="/">{t('errors.backHome')}</Link>
        </Button>
      </EmptyState>
    </div>
  )
}

export function NotFoundPage() {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-dvh items-center justify-center bg-surface-page">
      <EmptyState
        icon={SearchX}
        title={t('errors.notFoundTitle')}
        description={t('errors.notFoundDescription')}
      >
        <Button variant="outline" className="mt-2" asChild>
          <Link to="/">{t('errors.backHome')}</Link>
        </Button>
      </EmptyState>
    </div>
  )
}

export function RootErrorBoundary() {
  const { t } = useTranslation()
  const error = useRouteError()
  if (import.meta.env.DEV) console.error(error)
  return (
    <div className="flex min-h-dvh items-center justify-center bg-surface-page">
      <EmptyState
        icon={TriangleAlert}
        title={t('errors.crashTitle')}
        description={t('errors.crashDescription')}
      >
        <Button variant="outline" className="mt-2" onClick={() => window.location.reload()}>
          {t('errors.reload')}
        </Button>
      </EmptyState>
    </div>
  )
}

/** Placeholder for screens scheduled in a later build phase. */
export function ComingSoon({ title }: { title: string }) {
  const { t } = useTranslation()
  return <EmptyState icon={Construction} title={title} description={t('common.comingSoon')} />
}
